import { useFormikContext } from "formik";
import { draftPluginValidationSchema } from "../schemas/DraftPluginValidationSchema";
import { PluginDetails } from "../models/PluginDetails";
import { usePluginActions } from "./usePluginActions";
import { useParams } from "react-router-dom";
import { useLocalization } from "../../../contexts/LocalizationContext";
import { pluginValidationSchema } from "../schemas/PluginValidationSchema";
import { processMarkdownToHTML } from "../../../utils";
import { Action } from "../models/Action";

export const useDraftPluginButtonGroup = () => {
  const { values, setTouched, handleSubmit: submit } = useFormikContext<PluginDetails>();
  const { pluginId } = useParams();
  const { translate } = useLocalization();
  const { isLoading, pluginActions } = usePluginActions();

  const handleSaveAsDraft = async () => {
    try {
      await processMakrdownToHtml();
      await draftPluginValidationSchema(translate).validate(values, { abortEarly: false });
      setTouched({});
      if (pluginId) await pluginActions.handleUpdateDraft(parseInt(pluginId), values);
      else await pluginActions.handleCreateDraft(values);
    } catch (errors) {
      setTouched({ name: true, parentProductDetailsId: true });
    }
  };

  const handleSave = async () => {
    try {
      await processMakrdownToHtml();
      await pluginValidationSchema(translate).validate(values, { abortEarly: false });
      setTouched({});
      if (pluginId) await pluginActions.handleUpdate(parseInt(pluginId), values, Action.SaveWithCloneRemoval);
      else await pluginActions.handleCreate(values);
    } catch (errors) {
      submit();
    }
  };

  const handleSubmit = async () => {
    try {
      await processMakrdownToHtml();
      await pluginValidationSchema(translate).validate(values, { abortEarly: false });
      setTouched({});
      if (pluginId) await pluginActions.handleUpdatePending(parseInt(pluginId), values);
      else await pluginActions.handleCreatePending(values);
    } catch (errors) {
      submit();
    }
  };

  const processMakrdownToHtml = async () => {
    values.htmlDescription = await processMarkdownToHTML(values.markdownDescription, values.descriptionResources);
    values.htmlDocumentation = await processMarkdownToHTML(values.markdownDocumentation, values.documentationResources);
  };

  return { isLoading, handleSaveAsDraft, handleSave, handleSubmit };
};
